import { getLocalUser } from './helpers/auth';
const user = getLocalUser();
export default {
    state: {
        currentUser: user,
        isLoggedIn: !!user,
        loading: false,
        auth_error: null,
        categories: [],
        acount: [],
        authors: [],
        names: [],
        siteApps: [],
        siteLanguages:[],
        frontAppSlug: '',
        appslug: null,
        frontSelectedAppLangs:{}
        },

    getters: {
        categories(state) {
            return state.categories;
        },acount(state) {
            return state.acount;
        },authors(state) {
            return state.authors;
        },names(state) {
            return state.names;
        },isLoading(state) {
            return state.loading;
        },currentUser(state) {
            return state.currentUser;
        },authError(state) {
            return state.auth_error;
        },isLoggedIn(state) {
            return state.isLoggedIn;
        },siteApps(state) {
            return state.siteApps;
        },siteLanguages(state) {
            return state.siteLanguages;
        },frontAppSlug(state){
            return state.frontAppSlug;
        }
    },
    mutations: {
        updateCategories(state, payload) {
            state.categories = payload;
        },
        updateACount(state, payload) {
            state.acount = payload;
        },
        updateAuthors(state, payload) {
            state.authors = payload;
        },
        updatesNames(state, payload) {
            state.names = payload;
        }, login(state) {
            state.loading = true;
            state.auth_error = null;
        },
        loginSuccess(state, payload) {
            state.auth_error = null;
            state.isLoggedIn = true;
            state.loading = false;
            state.currentUser = Object.assign({}, payload.user, { token: payload.access_token });
            localStorage.setItem('user', JSON.stringify(state.currentUser));
        },
        loginFailed(state, payload) {
            state.loading = false;
            state.auth_error = payload;
        },
        logout(state) {
            localStorage.removeItem('user');
            state.isLoggedIn = false;
            state.currentUser = null;
        },
        updateSiteApps(state, payload) {
            state.siteApps = payload;
        },
        updateSiteLanguages(state, payload) {
            state.siteLanguages = payload;
        },
        updateFrontAppSlug(state, route) {
            state.frontAppSlug = route.params.app_slug;
        },
        /*
        SET_ROUTE(state, route) {
            console.log(route.params.slug);
            state.appslug = route.params.slug;
        }
        */
    },
    actions: {
        getCategories(context) {
            axios.get('/api/categories/'+localStorage.getItem('frontSelectedAppLang'))
                .then((response) => {
                    context.commit('updateCategories', response.data.category);
                    context.commit('updateACount', response.data.articles);
                    context.commit('updateAuthors', response.data.authors);
                    context.commit('updatesNames', response.data.names);
                })
        },
        login(context) {
            context.commit("login");
        },
        getSiteApps(context) {
            axios.get('/api/siteApps').then((response) => {
                context.commit('updateSiteApps', response.data.apps);
            })
        },
        getSiteLanguages(context) {
            axios.get('/api/languages').then((response) => {
                context.commit('updateSiteLanguages', response.data.languages);
            })
        },        
        getFrontAppSlug(context){
            //console.log('calling', context.state.frontAppSlug);
            //context.commit('updateFrontAppSlug');
        }
    }
}